export default "__VITE_ASSET__CUmX3Ko$__"